import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewDashBoad_Agendas = () => import('./Index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'dashboard_agendas',
        name: 'dashboard_agendas',
        component: ViewDashBoad_Agendas,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router